import React from 'react';
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';

interface Sight {
    id: string;
    name: string;
    description: string;
    latitude: number;
    longitude: number;
    imageUrl?: string;
}

interface MapViewProps {
    sights: Sight[];
    onSelectSight: (sight: Sight) => void;
}

const containerStyle = {
    width: '100%',
    height: '600px',
};

const center = {
    lat: 41.5801,
    lng: -71.4774,
};

const MapView: React.FC<MapViewProps> = ({ sights, onSelectSight }) => {
    const { isLoaded } = useJsApiLoader({
        //googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '',
        googleMapsApiKey: 'AIzaSyC9kynSm1yWhdNholf4FqtaAmhOFZXn6xU'
    });

    if (!isLoaded) {
        return <div>Loading map...</div>;
    }

    return (
        <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={10}
        >
            {sights.map((sight) => (
                <Marker
                    key={sight.id}
                    position={{ lat: sight.latitude, lng: sight.longitude }}
                    title={sight.name}
                    onClick={() => onSelectSight(sight)}
                />
            ))}
        </GoogleMap>
    );
};

export default React.memo(MapView);
